var map = {
	"./case-studies-grid/block.json": "./blocks/case-studies-grid/block.json",
	"./case-studies-stage/block.json": "./blocks/case-studies-stage/block.json",
	"./example-block/block.json": "./blocks/example-block/block.json",
	"./hero/block.json": "./blocks/hero/block.json",
	"./leistungen/block.json": "./blocks/leistungen/block.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./blocks sync recursive block\\.json";